import Vue from 'vue'
import Vuex from 'vuex'
// modules
import auth from './modules/auth'
// mf建議書modules
import mf from '@/desktop/views/mf/store';

// api
import { getCity } from '../../service/index'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,
        mf
    },
    getters: {
        SliceMode: () => {
            return process.env.NODE_ENV == "development" && process.env.VUE_APP_AGENCY == "AJA"
        },
        BaseUrl: () => {
            return process.env.BASE_URL
        },
        Cities: () => {
            return getCity()
        },
        PageLock: (state) => {
            return state.pageLock
        },
        UserInfo: (state) => {
            return state.userInfo
        },
        UserTokenKey: (state) => {
            return state.userTokenKey
        },
        CustInfo: (state) => {
            return state.custInfo
        },
        QueryKeyword: (state) => {
            return state.queryCustKeyword
        },
        SamlStatus: (state) => {
            if (process.env.NODE_ENV == "development" && process.env.VUE_APP_AGENCY == "AJA")
                return 'off'
            else
                return state.samlStatus
        },
        FilterData: (state) => {
            return state.filterData
        },
        HasHousingLoans: (state) => {
            return state.hasHousingLoans
        },
        UserRight: (state) => {
            return state.userRight
        },
        RouterPara: (state) => {
            return state.routerPara
        },
        UserItems: (state) => {
            return state.userItems
        },
        FamilyResultFilter: (state) => {
            return state.familyResultFilter
        },
        PDFData: (state) => {
            return state.PDFData
        },
        AllHolderSearchData: (state) => {
            return state.allHolderSearchData
        },
        LastFamilyResult: (state) => {
            return state.lastFamilyResult
        },
        CheckApc: (state) => {
            return state.checkApc
        },
        AllFamilyResult: (state) => {
            return state.allFamilyResult
        },
        SavePageData: (state) => {
            return state.savePageData
        },
        GetCategoryStatus: () => {
            return {
                "001" : "STATUS_MORE_BENEFITS",
                "002" : "STATUS_MEDICAL_CARE",
                "003" : "STATUS_ONE_LOVE",
                "004" : "STATUS_PHYSICAL_MENTAL_DISORDER",
                "005" : "STATUS_LONG_TERM_CARE",
                "006" : "STATUS_REAL_PAYING_TARGET",
                "007" : "STATUS_HONOR_SERVICE",
                "008" : "STATUS_PUSH_LIST",
                "009" : "STATUS_WELCOME_CEREMONY",
                "010" : "STATUS_HEALTH_CEREMONY",
                "011" : "STATUS_CATHAY_FAMILY",
                "012" : "STATUS_FREEHEALTH_CHECK",
                "013" : "STATUS_ONLINE_CONSULTATION",
                "014" : "STATUS_WILL_STOP_EFFECT",
                "015" : "STATUS_STOP_EFFECT_AFTER_HALF_YEAR",
                "016" : "STATUS_FULL_ANNUITY_NOT_HANDLE",
                "017" : "STATUS_UNPAID_CHECK",
                "019" : "STATUS_FOREIGN_CURRENCY_HANDLE_DISCOUNT",
                "020" : "STATUS_SECURITIES_DIGITAL_SERVICE",
                "021" : "STATUS_HIGH_ASSETS_REDELEGATION",
                "022" : "STATUS_CATHAY_WITH_YOUR_HEALTH",
                "023" : "STATUS_SUBSTANTIAL_CONTACT_DETAILS",
                "024" : "STATUS_SMALL_AMOUNT_OLD_AGE",
                "025" : "STATUS_WARRANTY_SHOULD_RECEIVE_NOT_RECEIVE",
                "026" : "STATUS_REMOTE_DOCUMENT_WARNING",
                "027" : "STATUS_MORE_BENEFITS",
                "028" : "STATUS_MEDICAL_CARE",
                "029" : "STATUS_ONE_LOVE",
                "030" : "STATUS_HANDLE_GROUP_REMITTANCE_NOTIFICATION",
                "031" : "STATUS_STOP_EFFECT",
                "032" : "STATUS_REAL_PAID",
                "033" : "STATUS_CAR_FIRE_INSURANCE_RESERVE",
                "034" : "STATUS_FULL_TARGET_CUSTOM",
                "035" : "STATUS_INSURANCE_ACTIVATION",
                "036" : "STATUS_MORE_BENEFITS",
                "037" : "STATUS_MEDICAL_CARE",
                "038" : "STATUS_ONE_LOVE",
                "039" : "STATUS_ECALL_SERVICE_ITEM",
                "040" : "STATUS_ANNUITY_TARGET_CUSTOM",
                "041" : "STATUS_CAR_INSURANCE_UNRENEWED",
                "042" : "STATUS_HAPPY_MIND_INSURANCE",
                "043" : "STATUS_STOP_EFFECT_QUERY",
                "044" : "STATUS_HIGH_POTENTIAL_NEW_CUSTOMER",
                "045" : "STATUS_CUSTOMER_APPLY_FOR_MEMBER",
                "046" : "STATUS_TAI_HOSPITABLE",
                "047" : "STATUS_DOLLAR_GUARANTEE",
                "048" : "STATUS_TRIPLE_CARE",
                "049" : "STATUS_PROFIT_GUARANTEE",
                "050" : "STATUS_I_ONLY_U",
                "051" : "STATUS_MIND_WITH_JOY",
                "052" : "STATUS_HIGH_CLASS_WHITE_COLLAR",
                "053" : "STATUS_NOT_APPLY_FOR_CWP",
                "054" : "STATUS_INJURY_INSURANCE_ADJUSTMENT",
                "055" : "STATUS_WEB_SERVICE_PUSH_LIST",
                "056" : "STATUS_INFO_ADJUSTMENT",
                "057" : "STATUS_SINCERE_GUARD",
                "058" : "STATUS_SUSPENSION_CARE",
                "059" : "STATUS_THE_REMOTE_DOCUMENT_WARNING",
                "060" : "STATUS_GROUP_INSURANCE_KEY_MAN",
                "061" : "STATUS_MEDICAL_EDM",
                "062" : "STATUS_DIE_CARE",
                "063" : "STATUS_UNDER_15_LIST",
                "064" : "STATUS_SPILLOVER_POLICY",
                //"065" : "STATUS_CARE_SERVICE",
                //"066" : "STATUS_EPIDEMIC_PREVENTION",
                "067" : "STATUS_CREDIT_CARD_VALIDATION",
                "068" : "STATUS_HOME_LOAN_LIST",
                "069" : "STATUS_PREMIUM_TRANSFORMATION",
                "070" : "STATUS_EVENT_DETECTION",
                //"071" : "STATUS_CUBE_CARD",
                "072" : "STATUS_EVENT_DETECTION_HIGHCOVERAGE",
                "073" : "STATUS_AGREED_DEDUCTION",
                "074" : "STATUS_EVENT_DETECTION_HR",
                "075" : "STATUS_FITBACK_LOVER",
                "076" : "STATUS_CUSTOMER_SURVEY",
                "077" : "STATUS_HIGH_NET_WORTH",
                "078" : "STATUS_POTENTIAL_HIGH_NET_WORTH",
                "079" : "STATUS_CUSTOMER_LIST_079",
                "080" : "STATUS_CUSTOMER_LIST_080"
            }
        },
        GetSerNoByStatus: (state, getters) => (status) => {
            const categoryStatus = getters.GetCategoryStatus;
            const serNo = Object.entries(categoryStatus).find(([key, value]) => value === status);
            return serNo ? serNo[0] : null
        },
        IsBFF_MX:() => {
            return true
        },
        IsBFF_MV:() => {
            return true
        },
        IsBFF_MF:() => {
            return true
        },
    },
    state: {
        news: [],
        videos: [],
        fromPagePath: '/', //  紀錄頁面是從哪個 path 過來的 
        routerPara: { // 紀錄 router 參數
            filterResult: {},
            managerTabOne: {},
        },
        listAreaSerNo: '',
        compositionStatus: false, // 注音輸入
        userIP: '1.2.3.4',
        pageLock: false,
        samlStatus: false,
        timeoutVal: 500,
        bulletinSerNo: '',
        custType: ['1', '2', '3', '4', '5', '6'],
        filterData: {},
        userInfo: {
            id: '',
            name: '',
            div_no: '',
            position: '',
            code_name: '',
            workDate: '',
            divNo: '',
        },
        userRight: { // 紀錄使用者權限
            CONTENT_MANAGEMENT_SYSTEM: false,
            CONTENT_VERIFICATION_SYSTEM: false,
            SUPERVISOR_AREA_01: false,
            SUPERVISOR_AREA_02: false,
            SUPERVISOR_AREA_03: false,
            SUPERVISOR_AREA_04: false,
            SUPERVISOR_AREA_05: false,
            SWITCH_USER: false,
            SYSTEM_MANAGEMENT: false,
            USER_PROFILE: false,
        },
        hasHousingLoans: false,
        userTokenKey: '',
        custInfo: {
            lv: 0,
            familyLeader: false,
            name: '',
            gender: 0,
            birthday: '',
            mobile: '',
            phone: ['', ''],
            fax: ['', ''],
            ID: '',
            serNo: '',
            office_phone: ['', '', ''],
            address: ['', '', '', ''],
            office_address: ['', '', '', ''],
            lineid: '',
            wg_name: '',
            relation: {},
        },
        queryCustKeyword: '',
        serviceLine: '2291、2177', //業務企劃科分機號碼(共用)
        userItems: [],
        familyResultFilter: [],
        allFamilyResult: [],
        PDFData: [],
        allHolderSearchData: [],
        lastFamilyResult: [],
        checkApc: false,
        prodMainCode: [],
        prodSubCode: [],
        act_type: "", //近期動態客戶列表類型
        savePageData: {},
        initCategoryStatus: "", //記錄點選的名單專區類別
        isQryResginUnlock: false, //是否查詢離退人員對應增員者是否解鎖
        resignInfo: {
            resign_id: "",
            resign_ceclcno: "",
            resign_name: "",
            intr_id: "",
            intr_ceclcno: "",
            intr_name: "",
            is_unlock: ""
        },
        isResignType: false, // 是否為離退職人員類型
        isBFF_MX:true, //MX BFF開關
        isBFF_MV:true, //MV BFF開關
        isBFF_MF:true //MF BFF開關
    },
    mutations: {
        updatefromPagePath: (state, payload) => { //  紀錄頁面是從哪個 path 過來的 
            state.fromPagePath = payload
        },
        updateCompositionStatus: (state, payload) => {
            state.compositionStatus = payload
        },
        updateListAreaSerNo: (state, payload) => { // 紀錄 名單專區 流水編
            state.listAreaSerNo = payload
        },
        updateRouterPara: (state, payload) => { // 紀錄 router 參數
            state.routerPara[payload.pathName] = payload.setData
        },
        updateUserRight: (state, payload) => {
            state.userRight = payload
        },
        updateUserIP: (state, payload) => {
            if (payload == '') {
                state.userIP = '1.2.3.4'
            } else {
                state.userIP = payload
            }
        },
        updatePageLock: (state, payload) => {
            state.pageLock = payload
        },
        updateUserInfo: (state, payload) => {
            state.userInfo = payload.data
        },
        updateUserToken: (state, payload) => {
            state.userTokenKey = payload
        },
        updateCustInfo: (state, payload) => {
            state.custInfo = payload
        },
        updateCustID: (state, payload) => {
            state.custInfo.ID = payload
        },
        updateSerNo: (state, payload) => {
            state.custInfo.serNo = payload
        },
        updateQueryKeyword: (state, payload) => {
            state.queryCustKeyword = payload
        },
        updateCustFamilyLeader: (state, payload) => {
            state.custInfo.familyLeader = payload
        },
        updateSamlStatus: (state, payload) => {
            state.samlStatus = payload
        },
        updateFilterData: (state, payload) => {
            state.filterData = payload
        },
        updaHousingLoans: (state, payload) => {
            state.hasHousingLoans = payload
        },
        updaCustType: (state, payload) => {
            state.custType = payload
        },
        updaBulletinSerNo: (state, payload) => { // 紀錄 佈告欄流水編
            state.bulletinSerNo = payload
        },
        updateUserItems: (state, payload) => {
            console.log("updateUserItems", state, payload)
            state.userItems = payload
        },
        updateFamilyResultFilter: (state, payload) => {
            state.familyResultFilter = payload
        },
        updatePDFData: (state, payload) => {
            state.PDFData = payload
        },
        updateAllHolderSearchData: (state, payload) => {
            state.allHolderSearchData = payload
        },
        updateLastFamilyResult: (state, payload) => {
            state.lastFamilyResult = payload
        },
        updateCheckApc: (state, payload) => {
            state.checkApc = payload
        },
        updateAllFamilyResult(state, payload) {
            state.allFamilyResult = payload
        },
        updateSavePageData(state, payload) {
            state.savePageData = payload
        },
        updateIsQryResginUnlock(state, payload) {
            state.isQryResginUnlock = payload
        },
        updateResignInfo(state, payload) {
            state.resignInfo = payload;
        },
        updateIsResignType(state, payload) {
            state.isResignType = payload;
        },
        updateIsBFF_MX(state, payload) {
            state.isBFF_MX = payload;
        },
        updateIsBFF_MV(state, payload) {
            state.isBFF_MV = payload;
        },
        updateIsBFF_MF(state, payload) {
            state.isBFF_MF = payload;
        }
    },
    actions: {
        updateCompositionStatus: (context, args) => {
            context.commit('updateCompositionStatus', args)
        },
        setListAreaSerNo: (context, args) => { // 紀錄 名單專區 流水編
            context.commit('updateListAreaSerNo', args)
        },
        setRouterPara: (context, args) => { // 紀錄 router 參數
            context.commit('updateRouterPara', args)
        },
        updateUserRight: (context, args) => {
            context.commit('updateUserRight', args)
        },
        setPageLock({ commit }, data) {
            commit('updatePageLock', data)
        },
        updateUserInfo(context, args) {
            context.commit('updateUserInfo', args)
        },
        updaCustType(context, args) {
            context.commit('updaCustType', args)
        },
        updateUserToken(context, args) {
            context.commit('updateUserToken', args)
        },
        updateUserIP(context, args) {
            context.commit('updateUserIP', args.data)
        },
        updateCustInfo(context, args) {
            context.commit('updateCustInfo', args)
        },
        updateCustID(context, args) {
            context.commit('updateCustID', args)
        },
        updateSerNo(context, args) {
            context.commit('updateSerNo', args)
        },
        updateQueryKeyword(context, args) {
            context.commit('updateQueryKeyword', args)
        },
        updateCustFamilyLeader(context, args) {
            context.commit('updateCustFamilyLeader', args)
        },
        updateSamlStatus(context, args) {
            context.commit('updateSamlStatus', args)
        },
        updateFilterData(context, args) {
            context.commit('updateFilterData', args)
        },
        updaHousingLoans(context, args) {
            context.commit('updaHousingLoans', args)
        },
        updaBulletinSerNo(context, args) {
            context.commit('updaBulletinSerNo', args)
        },
        updateUserItems(context, args) {
            context.commit('updateUserItems', args)
        },
        updateFamilyResultFilter(context, args) {
            context.commit('updateFamilyResultFilter', args)
        },
        updatePDFData(context, args) {
            context.commit('updatePDFData', args)
        },
        updateAllHolderSearchData(context, args) {
            context.commit('updateAllHolderSearchData', args)
        },
        updateLastFamilyResult(context, args) {
            context.commit('updateLastFamilyResult', args)
        },
        updateCheckApc(context, args) {
            context.commit('updateCheckApc', args)
        },
        updateIsQryResginUnlock(context, args) {
            context.commit('updateIsQryResginUnlock', args);
        },
        updateResignInfo(context, args) {
            context.commit('updateResignInfo', args);
        },
        updateIsResignType(context, args) {
            context.commit('updateIsResignType', args);
        }
    }
})